module.exports = __webpack_public_path__ + "img/FCST-ability-02.a860f055.png";